import React, { Component } from 'react';
import ImageForm from './ImageForm';
import Edit from '../../common/Edit';
export default class ImageEdit extends Component {
  render() {
    return (
      <Edit
        resource={'image'}
        resourceId={this.props.params.id}
        component={ImageForm}
      />
    );
  }
}
